import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const TextareaContainer = styled.div`
    padding-top: ${({ theme }) => theme.spacing[4]};
`;
